import { useQuery, useQueryClient } from '@tanstack/react-query';

export function usePromoClicked() {
  const queryClient = useQueryClient();
  const { data } = useQuery({
    queryKey: ['hasClickedPromo'],
    queryFn: () => {
      return {
        hasClickedAnalyticsPromo: (global as any).hasClickedAnalyticsPromo as boolean,
      };
    },
  });

  const hasBeenClicked = data?.hasClickedAnalyticsPromo || false;

  const setPromoClicked = () => {
    (global as any).hasClickedAnalyticsPromo = true;
    queryClient.invalidateQueries({ queryKey: ['hasClickedPromo'] });
  };

  const hidePromo = async (limited: boolean) => {
    // Hide for 6 months or 100 years
    await window.lsCloud.UserPreferences.save(
      'view',
      'analytics_promo',
      'analytics_promo_dismissed_until',
      limited
        ? new Date(new Date().setMonth(new Date().getMonth() + 6)).toISOString()
        : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString()
    );
  };

  return { hasBeenClicked, setPromoClicked, hidePromo };
}

// Debug clear helper
(window as any).clearPromoClicked = async () => {
  if (window.getEnvFromHostname() !== 'production') {
    await window.lsCloud.UserPreferences.save(
      'view',
      'analytics_promo',
      'analytics_promo_dismissed_until',
      new Date(0).toISOString()
    );
  }
};
